import React, { useState, useEffect } from 'react'
import { Container, Card, Row, Col, Dropdown, OverlayTrigger, Tooltip, Button, Modal, Nav, Tab, Badge, ProgressBar } from 'react-bootstrap'
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { STUDENT_TEST_DETAILS_API, STUDENT_TEST_SCORE_CALCULATOR_API, TEACHERS_HELPER_ANSWER_SAVE_API, TEACHERS_QUESTIONS_LIST_API } from "../../api/constants";
import Moment from 'moment';
import ShareModal from '../../components/ai/ShareModal';
import NoDataFound from '../noDataFound';
import { InView } from "react-intersection-observer";
import loader from '../../assets/images/page-img/page-load-loader.gif'
import { useMemo } from 'react';

//Sweet alert
import Swal from 'sweetalert2'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';

const StudentHomeworkComp = ({ upcomingHWList, pastHWList, setShowMoreDataLoader }) => {

    const navigate = useNavigate();
    let profileData = (useSelector((state) => state.setting.setting.user_data))
    profileData = profileData ? JSON.parse(profileData) : "";
    const [showExamModal, setShowExamModal] = useState(false);
    const [examSection, setExamSection] = useState(null); // "MCQ", "SAQ", "LAQ"
    const [examQuestions, setExamQuestions] = useState([]);
    const [currentQuestionIdx, setCurrentQuestionIdx] = useState(0);
    const [userAnswers, setUserAnswers] = useState({});
    const [examSubmitted, setExamSubmitted] = useState(false);
    const [studentTestDetails, setStudentTestDetails] = useState('');
    const [showResultModal, setShowResultModal] = useState(false);

    useEffect(() => {
        if (studentTestDetails && studentTestDetails.questions) {
            setShowResultModal(true);
        }
    }, [studentTestDetails]);

    useEffect(() => {

    }, []);

    const groupTestsByDate = (searches) => {
        if (!Array.isArray(searches)) return {};
        const grouped = {};
        searches.forEach(test => {
            // Count total questions
            const q = test.questions || {};
            const totalQuestions =
                (q.mcqs?.length || 0) +
                (q.saqs?.length || 0) +
                (q.laqs?.length || 0) +
                (q.nonWeighted?.length || 0);

            // Only include tests with at least 1 question
            if (totalQuestions > 0) {
                const date = test?.test_details?.test_date
                    ? Moment(test.test_details.test_date).format('YYYY-MM-DD')
                    : 'No Date';
                if (!grouped[date]) grouped[date] = [];
                grouped[date].push(test);
            }
        });
        return grouped;
    };

    const groupedTests = useMemo(() => groupTestsByDate(upcomingHWList), [upcomingHWList]);
    const [selectedTest, setSelectedTest] = useState(null);

    // Handle answer change
    const handleAnswerChange = (qid, value) => {
        setUserAnswers(prev => ({ ...prev, [qid]: value }));
    };

    // Next/Prev navigation
    const handleNext = () => {
        const q = examQuestions[currentQuestionIdx];
        const selectedLabel = userAnswers[q.id]; // e.g., "B."
        let selectedText = "";
        if (selectedLabel && q.options) {
            const opts = Array.isArray(q.options) ? q.options : JSON.parse(q.options);
            const idx = selectedLabel.charCodeAt(0) - 65;
            if (opts[idx]) {
                selectedText = opts[idx];
            }
        }
        // Save answer (async, but move to next question immediately)
        // console.log("Selected label:", selectedLabel);
        // console.log("Selected text:", selectedText);
        // console.log("Selected text:", q);
        if (q?.type === "mcq" && selectedText !== "") {
            const optionId = q.mcq_options ? q.mcq_options.findIndex(opt => opt.option_text === selectedText) : null;
            saveAnswerApi(q.id, (selectedText || selectedLabel || ""), q.mcq_options[optionId]?.id, false);
        } else {
            saveAnswerApi(q.id, (selectedText || selectedLabel || ""), false);
        }
        setCurrentQuestionIdx(idx => idx + 1);
    };

    const handlePrev = () => setCurrentQuestionIdx(idx => idx - 1);

    // Submit exam
    const handleSubmitExam = () => {
        const q = examQuestions[currentQuestionIdx];
        const selectedLabel = userAnswers[q.id]; // e.g., "B."
        let selectedText = "";
        if (selectedLabel && q.options) {
            const opts = Array.isArray(q.options) ? q.options : JSON.parse(q.options);
            const idx = selectedLabel.charCodeAt(0) - 65;
            if (opts[idx]) {
                // Get the full option text including "A. ...", "B. ...", etc.
                selectedText = opts[idx];
            }
        }
        // console.log("Selected label:", selectedLabel);
        // console.log("Selected text:", selectedText);

        // Save answer and go to next
        if (q?.type === "mcq" && selectedText !== "") {
            const optionId = q.mcq_options ? q.mcq_options.findIndex(opt => opt.option_text === selectedText) : null;
            saveAnswerApi(q.id, (selectedText || selectedLabel || ""), q.mcq_options[optionId]?.id, true);
        } else {
            saveAnswerApi(q.id, (selectedText || selectedLabel || ""), true);
        }
        // setExamSubmitted(true);
        // You can send userAnswers to API here if needed
    };

    async function saveAnswerApi(qId, studentAnswer, optionId, isSubmit) {
        setShowMoreDataLoader(true)
        let params = null
        if (isSubmit) {
            params = {
                question_id: qId,
                student_answer: studentAnswer,
                option_ids: (optionId !== "" && optionId !== null) ? optionId : {},
                is_submitted: 1,
            }
        } else {
            params = {
                question_id: qId,
                student_answer: studentAnswer,
                option_ids: (optionId !== "" && optionId !== null) ? optionId : {},
                is_submitted: 0,
            }
        }
        try {
            const res = await apiHandler(TEACHERS_HELPER_ANSWER_SAVE_API, "POST", params)
            if (res.data?.response?.status === 200) {
                if (isSubmit) {
                    getScoreCalculatorApi()
                }
                // Remove: else { setCurrentQuestionIdx(idx => idx + 1) }
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getScoreCalculatorApi() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(STUDENT_TEST_SCORE_CALCULATOR_API, "POST", {
                ai_search_id: selectedTest?.ai_search_id,
                student_id: profileData?.id,
            })
            if (res.data?.response?.status === 200) {
                setExamSubmitted(true);
                setShowExamModal(false);

                Swal.fire({
                    title: 'Success',
                    text: 'Your homework has been submitted successfully.',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getStudentTestDetailsApi(aiSearchId) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(STUDENT_TEST_DETAILS_API, "POST", {
                ai_search_id: aiSearchId,
            })
            if (res.data?.response?.status === 200) {
                setStudentTestDetails(res.data?.data?.test_details || '');
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    const renderPastTestListByDate = () => (
        <div >
            <div className="row g-4">
                {pastHWList.length === 0 && (
                    <NoDataFound txtData="Sorry! at the moment there are no past homework." />
                )}
                {pastHWList.map((test, idx) => (
                    <li className="d-flex mb-0 question-card-new" key={idx}>
                        <div key={test.ai_search_id} className="col-12 col-md-12">
                            <div
                                className="test-card-modern past-test-card shadow-sm"
                                style={{
                                    width: "100%",
                                    // background: "linear-gradient(120deg, #f3e5f5 0%, #fff 100%)",
                                    // border: "1.5px solid #e0e0e0",
                                    // borderRadius: 18,
                                    // boxShadow: "0 2px 16px #7e57c211",
                                    padding: 10,
                                    marginBottom: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    // transition: "box-shadow 0.2s, border 0.2s, background 0.2s"
                                }}
                            >
                                <div className="d-flex align-items-center mb-0">
                                    {/* <div className="rounded-circle bg-purple d-flex align-items-center justify-content-center me-3" style={{ width: 24, height: 24 }}>
                                                        <i className="material-symbols-outlined text-white" style={{ fontSize: 16 }}>task_alt</i>
                                                    </div> */}
                                    <div>
                                        <div className="fw-bold" style={{ fontSize: 14, color: "primaryColor" }}>
                                            {test.topic}
                                        </div>
                                        <div className="mb-1 d-flex flex-wrap gap-2">
                                            {test.test_details?.test_date && (
                                                <span
                                                    style={{
                                                        // background: "#ede7f6",
                                                        // color: "#7e57c2",
                                                        // borderRadius: 8,
                                                        // padding: "2px 10px",
                                                        fontWeight: 600,
                                                        fontSize: 10,
                                                        display: "inline-block",
                                                        marginTop: 2
                                                    }}
                                                >
                                                    <i className="material-symbols-outlined align-middle" style={{ fontSize: 12, verticalAlign: "middle" }}>calendar_today</i>
                                                    {" "}{Moment(test.test_details.test_date).format('YYYY-MM-DD')}
                                                </span>
                                            )}
                                            {test.test_details?.exam_score && (
                                                <span
                                                    style={{
                                                        // background: "#fff3cd",
                                                        // color: "#856404",
                                                        // borderRadius: 8,
                                                        // padding: "2px 10px",
                                                        fontWeight: 600,
                                                        fontSize: 10,
                                                        display: "inline-block"
                                                    }}
                                                >
                                                    <i className="material-symbols-outlined align-middle" style={{ fontSize: 12, verticalAlign: "middle" }}>star</i>
                                                    {" "}Marks: {test.test_details.exam_score} ({test.test_details.test_duration} min)
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="mb-2 d-flex flex-wrap gap-2">
                                                    {test.questions?.mcqs?.length > 0 && (
                                                        <span className="badge bg-primary">{test.questions.mcqs.length} MCQ</span>
                                                    )}
                                                    {test.questions?.saqs?.length > 0 && (
                                                        <span className="badge bg-success">{test.questions.saqs.length} SAQ</span>
                                                    )}
                                                    {test.questions?.laqs?.length > 0 && (
                                                        <span className="badge bg-warning text-dark">{test.questions.laqs.length} LAQ</span>
                                                    )}
                                                    {test.questions?.nonWeighted?.length > 0 && (
                                                        <span className="badge bg-secondary">{test.questions.nonWeighted.length} NonWeighted</span>
                                                    )}
                                                </div> */}
                                {/* <div className="mb-2 d-flex flex-wrap gap-2">
                                                    {test.test_details?.exam_score && (
                                                        <span
                                                            style={{
                                                                background: "#fff3cd",
                                                                color: "#856404",
                                                                borderRadius: 8,
                                                                padding: "2px 10px",
                                                                fontWeight: 600,
                                                                fontSize: 14,
                                                                display: "inline-block"
                                                            }}
                                                        >
                                                            <i className="material-symbols-outlined align-middle" style={{ fontSize: 16, verticalAlign: "middle" }}>star</i>
                                                            {" "}Marks: {test.test_details.exam_score}
                                                        </span>
                                                    )}
                                                    {test.test_details?.test_duration && (
                                                        <span
                                                            style={{
                                                                background: "#e8f5e9",
                                                                color: "#388e3c",
                                                                borderRadius: 8,
                                                                padding: "2px 10px",
                                                                fontWeight: 600,
                                                                fontSize: 14,
                                                                display: "inline-block"
                                                            }}
                                                        >
                                                            <i className="material-symbols-outlined align-middle" style={{ fontSize: 16, verticalAlign: "middle" }}>timer</i>
                                                            {" "}Duration: {test.test_details.test_duration} min
                                                        </span>
                                                    )}
                                                </div> */}
                                <div className="d-flex justify-content-end mt-3">
                                    {
                                        test.test_details?.is_result_published === 1 &&
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            className="rounded-pill px-3"
                                            onMouseDown={e => e.preventDefault()}
                                            onClick={() => {
                                                setSelectedTest(test);
                                                // handleStartExamSection(test);
                                                getStudentTestDetailsApi(test?.ai_search_id)
                                            }}
                                        >
                                            <i className="material-symbols-outlined align-middle me-1">visibility</i>
                                            View Results
                                        </Button>
                                    }
                                    {
                                        test.test_details?.is_submitted === 1 && test.test_details?.is_result_published === 0 &&
                                        <span
                                            style={{
                                                background: "#e8f5e9",
                                                color: "#388e3c",
                                                borderRadius: 8,
                                                padding: "2px 10px",
                                                fontWeight: 600,
                                                fontSize: 12,
                                                display: "inline-block"
                                            }}
                                        >
                                            {" "}Result not published
                                        </span>
                                    }
                                    {
                                        !test.test_details?.is_submitted &&
                                        <span
                                            style={{
                                                background: "#fff3cd",
                                                color: "#856404",
                                                borderRadius: 8,
                                                padding: "2px 10px",
                                                fontWeight: 600,
                                                fontSize: 12,
                                                display: "inline-block"
                                            }}
                                        >
                                            {/* <i className="material-symbols-outlined align-middle" style={{ fontSize: 16, verticalAlign: "middle" }}>star</i> */}
                                            {" "}Absent
                                        </span>
                                    }
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </div>
            <style>{`
             .test-card-modern:hover {
               box-shadow: 0 0 0 2px #1976d233, 0 4px 24px #1976d211;
               border-color: #1976d2 !important;
               background: linear-gradient(100deg, #e3f2fd 60%, #fff 100%);
             }
             @media (max-width: 767px) {
               .test-card-modern {
                 min-width: 90vw !important;
                 max-width: 100vw !important;
               }
             }
           `}</style>
        </div >
    );

    // Render test list by date
    const renderTestListByDate = () => (
        <div className="row g-4">
            {Object.keys(groupedTests).length === 0 && (
                <NoDataFound txtData="Sorry! at the moment there are no homework." />
            )}
            {Object.entries(groupedTests).map(([date, tests]) => (
                <React.Fragment key={date}>
                    {tests.map(test => (
                        <div
                            key={test.ai_search_id}
                            className="col-12 "
                            style={{ display: "flex" }}
                        >
                            <div
                                className="test-card-modern flex-fill"
                                style={{
                                    width: "100%",
                                    background: "#fff",
                                    border: "1.5px solid #e0e0e0",
                                    borderRadius: 18,
                                    boxShadow: "0 2px 16px #1976d211",
                                    padding: 20,
                                    marginBottom: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    transition: "box-shadow 0.2s, border 0.2s, background 0.2s"
                                }}
                            >
                                <div>
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center me-3" style={{ width: 44, height: 44 }}>
                                            <i className="material-symbols-outlined text-white" style={{ fontSize: 26 }}>quiz</i>
                                        </div>
                                        <div>
                                            <div className="fw-bold" style={{ fontSize: 18, color: "#1976d2" }}>
                                                {test.topic}
                                            </div>
                                            <div className="small text-secondary">
                                                {test.test_details?.test_date && (
                                                    <span
                                                        style={{
                                                            background: "#e3f2fd",
                                                            color: "#1976d2",
                                                            borderRadius: 8,
                                                            padding: "2px 10px",
                                                            fontWeight: 600,
                                                            fontSize: 14,
                                                            display: "inline-block",
                                                            marginTop: 2
                                                        }}
                                                    >
                                                        <i className="material-symbols-outlined align-middle" style={{ fontSize: 16, verticalAlign: "middle" }}>calendar_today</i>
                                                        {" "}{Moment(test.test_details.test_date).format('YYYY-MM-DD')}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* Only show question type badges if present, but no highlight */}
                                    <div className="mb-2 d-flex flex-wrap gap-2">
                                        {test.questions?.mcqs?.length > 0 && (
                                            <span>{test.questions.mcqs.length} MCQ</span>
                                        )}
                                        {test.questions?.saqs?.length > 0 && (
                                            <span>{test.questions.saqs.length} SAQ</span>
                                        )}
                                        {test.questions?.laqs?.length > 0 && (
                                            <span>{test.questions.laqs.length} LAQ</span>
                                        )}
                                        {test.questions?.nonWeighted?.length > 0 && (
                                            <span>{test.questions.nonWeighted.length} NonWeighted</span>
                                        )}
                                    </div>
                                    <div className="mb-2 d-flex flex-wrap gap-2">
                                        {test.test_details?.exam_score && (
                                            <span
                                                style={{
                                                    background: "#e8f5e9", //"#fff3cd",
                                                    color: "#388e3c", //"#856404",
                                                    borderRadius: 8,
                                                    padding: "2px 10px",
                                                    fontWeight: 600,
                                                    fontSize: 14,
                                                    display: "inline-block"
                                                }}
                                            >
                                                <i className="material-symbols-outlined align-middle" style={{ fontSize: 16, verticalAlign: "middle" }}>star</i>
                                                {" "}Marks: {test.test_details.exam_score} ({test.test_details.test_duration} min)
                                            </span>
                                        )}
                                        {/* {test.test_details?.test_duration && (
                                            <span
                                                style={{
                                                    background: "#e8f5e9",
                                                    color: "#388e3c",
                                                    borderRadius: 8,
                                                    padding: "2px 10px",
                                                    fontWeight: 600,
                                                    fontSize: 14,
                                                    display: "inline-block"
                                                }}
                                            >
                                                <i className="material-symbols-outlined align-middle" style={{ fontSize: 16, verticalAlign: "middle" }}>timer</i>
                                                {" "}Duration: {test.test_details.test_duration} min
                                            </span>
                                        )} */}
                                    </div>
                                    {/* {test.purpose && (
                                            <div className="small text-success mb-1">
                                                <i className="material-symbols-outlined align-middle" style={{ fontSize: 16 }}>flag</i>
                                                {" "}{test.purpose}
                                            </div>
                                            )} */}
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    {((test.test_details?.test_date && Moment(test.test_details.test_date).format('YYYY-MM-DD') === Moment().format('YYYY-MM-DD')) &&
                                        test?.test_details?.is_submitted === false) && (
                                            <Button
                                                variant="success"
                                                size="sm"
                                                className="rounded-pill px-3"
                                                onClick={() => {
                                                    setSelectedTest(test);
                                                    handleStartExamSection(test);
                                                }}
                                            >
                                                <i className="material-symbols-outlined align-middle me-1">play_circle</i>
                                                Start Homework
                                            </Button>
                                        )}
                                </div>
                            </div>
                        </div>
                    ))}
                </React.Fragment>
            ))}
            <style>{`
             .test-card-modern:hover {
               box-shadow: 0 0 0 2px #1976d233, 0 4px 24px #1976d211;
               border-color: #1976d2 !important;
               background: linear-gradient(100deg, #e3f2fd 60%, #fff 100%);
             }
             @media (max-width: 767px) {
               .test-card-modern {
                 min-width: 90vw !important;
                 max-width: 100vw !important;
               }
             }
           `}</style>
        </div>

    );

    // Update handleStartExamSection to accept selectedTest
    const handleStartExamSection = (testObj = null) => {
        const test = testObj || selectedTest;
        if (!test) return;

        let arr = [];

        // Helper to map MCQ options
        const mapMcqOptions = (mcq) => ({
            ...mcq,
            options: mcq.mcq_options ? mcq.mcq_options.map(opt => opt.option_text) : [],
            section: "MCQ"
        });

        // Helper for SAQ/LAQ/nonWeighted
        const mapOther = (q, section) => ({
            ...q,
            options: null,
            section
        });

        // Combine all question types into one array
        if (Array.isArray(test.questions.mcqs)) {
            arr = arr.concat(test.questions.mcqs.map(mapMcqOptions));
        }
        if (Array.isArray(test.questions.saqs)) {
            arr = arr.concat(test.questions.saqs.map(q => mapOther(q, "SAQ")));
        }
        if (Array.isArray(test.questions.laqs)) {
            arr = arr.concat(test.questions.laqs.map(q => mapOther(q, "LAQ")));
        }
        if (Array.isArray(test.questions.nonWeighted)) {
            arr = arr.concat(test.questions.nonWeighted.map(q => mapOther(q, "nonWeighted")));
        }

        setExamSection("Exam");
        setExamQuestions(arr);
        setCurrentQuestionIdx(0);
        setUserAnswers({});
        setExamSubmitted(false);
        setShowExamModal(true);
    };

    // Render question UI
    const renderExamQuestion = () => {
        if (!examQuestions.length) return (
            <div className="text-center py-5 text-muted">
                <i className="material-symbols-outlined" style={{ fontSize: 48 }}>quiz</i>
                <div>No homework available for this section.</div>
            </div>
        );
        const q = examQuestions[currentQuestionIdx];
        return (
            <div className="p-2 p-md-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <Badge bg={
                        q.section === "MCQ" ? "primary" :
                            q.section === "SAQ" ? "success" :
                                q.section === "LAQ" ? "warning" : "secondary"
                    } className="fs-6 px-3 py-2 text-uppercase shadow-sm">
                        {q.section}
                    </Badge>
                    <span className="fw-bold text-secondary">
                        Q{currentQuestionIdx + 1} <span className="text-muted">/ {examQuestions.length}</span>
                    </span>
                </div>
                <ProgressBar
                    now={((currentQuestionIdx + 1) / examQuestions.length) * 100}
                    className="mb-4"
                    style={{ height: 8, borderRadius: 8 }}
                    variant={
                        q.section === "MCQ" ? "primary" :
                            q.section === "SAQ" ? "success" :
                                q.section === "LAQ" ? "warning" : "secondary"
                    }
                />
                <div className="mb-4 p-3 rounded bg-light border shadow-sm" style={{ fontSize: 20, fontWeight: 600, color: "#1976d2" }}>
                    {q.question_text}
                </div>
                {q.section === "MCQ" && q.options && (
                    <div className="mb-4">
                        {q.options.map((opt, i) => {
                            const label = String.fromCharCode(65 + i) + ".";
                            return (
                                <div key={i} className="form-check mb-2 ps-4">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name={`answer_${q.id}`}
                                        id={`opt_${q.id}_${i}`}
                                        value={label}
                                        checked={userAnswers[q.id] === label}
                                        onChange={() => handleAnswerChange(q.id, label)}
                                        disabled={examSubmitted}
                                        style={{ cursor: examSubmitted ? "not-allowed" : "pointer" }}
                                    />
                                    <label className="form-check-label ms-2" htmlFor={`opt_${q.id}_${i}`} style={{ cursor: examSubmitted ? "not-allowed" : "pointer" }}>
                                        <span className="option-label fw-bold">{label}</span> {opt}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                )}
                {q.section !== "MCQ" && (
                    <div className="mb-4">
                        <textarea
                            className="form-control shadow-sm"
                            rows={4}
                            placeholder="Type your answer..."
                            value={userAnswers[q.id] || ""}
                            onChange={e => handleAnswerChange(q.id, e.target.value)}
                            disabled={examSubmitted}
                            style={{ fontSize: 16 }}
                        />
                    </div>
                )}
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        variant="outline-secondary"
                        disabled={currentQuestionIdx === 0}
                        onClick={handlePrev}
                    >
                        <i className="material-symbols-outlined align-middle me-1">arrow_back</i> Previous
                    </Button>
                    {currentQuestionIdx < examQuestions.length - 1 ? (
                        <Button
                            variant="primary"
                            onClick={handleNext}
                            disabled={examSubmitted}
                        >
                            Next <i className="material-symbols-outlined align-middle ms-1">arrow_forward</i>
                        </Button>
                    ) : (
                        <Button
                            variant="success"
                            onClick={handleSubmitExam}
                            disabled={examSubmitted}
                        >
                            {examSubmitted ? (
                                <span><i className="material-symbols-outlined align-middle me-1">check_circle</i> Submitted</span>
                            ) : (
                                <span><i className="material-symbols-outlined align-middle me-1">send</i> Submit</span>
                            )}
                        </Button>
                    )}
                </div>
                {examSubmitted && (
                    <div className="alert alert-success mt-4 text-center">
                        <i className="material-symbols-outlined align-middle me-2">check_circle</i>
                        Exam submitted! Thank you for your answers.
                    </div>
                )}
            </div>
        );
    };

    const renderStudentTestResult = () => {
        if (!studentTestDetails || !studentTestDetails.questions) return null;
        return (
            <div>
                <div className="mb-3 text-center">
                    <h5 className="fw-bold text-primary">{studentTestDetails.topic}</h5>
                    <div>
                        <Badge bg="info" className="me-2">{Moment(studentTestDetails.test_date).format('DD MMM YYYY')}</Badge>
                        <Badge bg="success" className="me-2">Score: {studentTestDetails.obtained_score} / {studentTestDetails.exam_score}</Badge>
                    </div>
                </div>
                {studentTestDetails.questions.map((q, idx) => (
                    <div key={q.question_id} className="question-card mb-3 p-3 rounded shadow-sm" style={{ background: "#f8f9fa" }}>
                        <div className="fw-bold mb-2" style={{ color: "#1976d2" }}>
                            Q{idx + 1}: {q.question_text}
                        </div>
                        <div className="mb-1">
                            <span className="badge bg-secondary me-2">Type: {q.type.toUpperCase()}</span>
                            <span className={`badge ${q.is_correct ? "bg-success" : "bg-danger"}`}>
                                {q.is_correct ? "Correct" : "Incorrect"}
                            </span>
                            <span className="badge bg-info ms-2">Score: {q.score}</span>
                        </div>
                        <div className="mt-2">
                            <div>
                                <span className="fw-semibold text-muted">Correct Answer:</span>
                                {q.correct_answer?.map((ans, i) => (
                                    <span key={ans.id} className="ms-2 badge bg-success">{ans.option_text}</span>
                                ))}
                            </div>
                            <div className="mt-1">
                                <span className="fw-semibold text-muted">Your Answer:</span>
                                {q.student_answer?.map((ans, i) => (
                                    <span key={ans.id} className="ms-2 badge bg-primary">{ans.option_text}</span>
                                ))}
                            </div>
                        </div>
                        {q.feedback && (
                            <div className="mt-2 alert alert-info p-2">
                                <i className="material-symbols-outlined align-middle me-1">info</i>
                                {q.feedback}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    };


    return (
        <Row>
            <Col lg="4">
                <Card>
                    <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                            <h4 className="card-title">Past Homework</h4>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <div className="d-flex mt-0 mb-3">
                            {renderPastTestListByDate()}
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col lg="8">
                <Card>
                    <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                            <h4 className="card-title">Upcoming Homework</h4>
                        </div>
                    </Card.Header>
                    <Card.Body className="bg-gradient" style={{ background: "linear-gradient(135deg, #e0e7ff 0%, #fff 100%)" }}>
                        <div className="d-flex mt-0 mb-3">
                            {renderTestListByDate()}
                        </div>

                        <Modal
                            show={showExamModal}
                            onHide={() => setShowExamModal(false)}
                            centered
                            size="lg"
                            backdrop="static"
                            keyboard={false}
                            contentClassName="rounded-4"
                        >
                            <Modal.Header closeButton className="bg-light rounded-top-4">
                                <Modal.Title>
                                    <span className="fw-bold text-primary">{examSection ? `${examSection}` : "Exam"}</span>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="bg-white rounded-bottom-4">
                                {renderExamQuestion()}
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showResultModal}
                            onHide={() => { setShowResultModal(false); setStudentTestDetails(''); }}
                            centered
                            size="lg"
                            backdrop="static"
                            keyboard={false}
                            contentClassName="rounded-4"
                            dialogClassName="responsive-modal"
                        >
                            <Modal.Header closeButton className="bg-light rounded-top-4" style={{ borderBottom: "1px solid #eee" }}>
                                <Modal.Title>
                                    <span className="fw-bold text-primary">Test Results</span>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="bg-white rounded-bottom-4" style={{ maxHeight: "70vh", overflowY: "auto", paddingBottom: 24 }}>
                                {renderStudentTestResult()}
                            </Modal.Body>
                        </Modal>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default StudentHomeworkComp